<template>
    <div class="rangepicker">
        <div class="selection">
            <ul class="rangepicker-tabs">
                <li :class="{ active: range === 'day' }" @click="setDay">{{ $t('label.day') }}</li>
                <li  :class="{ active: range === 'week' }" @click="setWeek">{{ $t('label.week') }}</li>
                <li :class="{ active: range === 'month' }" @click="setMonth">{{ $t('label.month') }}</li>
                <!--<li :class="{ active: range === 'year' }" @click="setYear">{{ $t('label.year') }}</li>-->
            </ul>
        </div>
        <header>
            <ul class="rangepicker-controls">
                <li @click="prev"><icon class="bright" name="prev" /></li>
                <li @click="current"><icon class="bright" name="circle_o" /></li>
                <li @click="next"><icon class="bright" name="next" /></li>
            </ul>
            <span @click.prevent="toggleCalendar">{{ timeframe | formatDate(range) }}</span>
            <div class="rangepicker-controls--right" v-if="range != 'month' && range != 'year'">
                <button class="btn" :class="{
                    active: showCalendar && calendarVisible,
                    disabled: ! calendarVisible
                }" 
                    @click.prevent="toggleCalendar">
                    <icon name="calendar"></icon>
                </button>
            </div>
        </header>
        <calendar v-if="showCalendar && range !== 'month' && range !== 'year'" :callback="handleCalendarSelectionFrom" :selected="calendarRange" :range="range" mode="range" />
    </div>
</template>

<script>
export default
{
    name: 'Rangepicker',

    props: [],

    data() {
        return {
            area: 'current',
            range: 'week',
            relativeToNow: 0,
            showCalendar: false,
            calendarRange: [],
        }
    },

    filters:
    {
        formatDate(val, range)
        {
            if (range === 'month') return moment(val[0]).format('MMMM YYYY');
            if (val.length > 1) return moment(val[0]).format('dd, DD.MM.YY') + ' — ' + moment(val[1]).format('dd, DD.MM.YY');
            return moment(val[0]).format('dd, DD.MM.YY');
        }
    },

    created()
    {
        this.calendarRange = this.fillRange(this.timeframe);
        this.emitDates();
    },

    computed:
    {
        timeframe()
        {
            if (this.range === 'day') return this.day;
            if (this.range === 'week') return this.week;
            if (this.range === 'month') return this.month;
            if (this.range === 'year') return this.year;

//            if (this.calendarRange.length === 1 || this.range === 'day') return [this.calendarRange[0]];
//            if (this.calendarRange.length > 1) return [this.calendarRange[0], this.calendarRange[this.calendarRange.length - 1]];

            return [];
        },

        day()
        {
            if (this.area === 'current')
                return [moment()];

            return [moment().add(this.relativeToNow, 'day')];
        },

        week()
        {
            if (this.area === 'current')
                return [moment().startOf('week'), moment().endOf('week')];

            return [moment().add(this.relativeToNow, 'day').startOf('week'), moment().add(this.relativeToNow, 'day').endOf('week')];
        },

        month()
        {
            if (this.area === 'current')
                return [moment().startOf('month'), moment().endOf('month')];

            return [moment().add(this.relativeToNow, 'day').startOf('month'), moment().add(this.relativeToNow, 'day').endOf('month')];
        },

        year()
        {
            if (this.area === 'current')
                return [moment().startOf('year'), moment().endOf('year')];

            return [moment().add(this.relativeToNow, 'day').startOf('year'), moment().add(this.relativeToNow, 'day').endOf('year')];
        },

        calendarVisible()
        {
            return this.range !== 'month' || this.range !== 'year';
        }
    },

    methods:
    {
        fillRange(timeframe)
        {
            if (! timeframe.length) return [];

            let range = [];
            let startDate = moment(timeframe[0]);
            let endDate = moment(timeframe[timeframe.length - 1]);

            while (startDate.isBefore(endDate) || startDate.isSame(endDate))
            {
                range.push(startDate.format('YYYY-MM-DD'));
                startDate.add(1, 'days');
            }

            return range;
        },

        toggleCalendar()
        {
            if ( ! this.calendarVisible) return;
            
            this.showCalendar =! this.showCalendar;
        },

        current()
        {
            this.area = 'current';
            this.relativeToNow = 0;
            this.calendarRange = this.fillRange(this.timeframe);
            this.emitDates();
        },

        prev()
        {
            this.area = 'prev';
            if (this.range === 'day') this.relativeToNow--;
            else if (this.range === 'week') this.relativeToNow -= 7;
            else if (this.range === 'month') this.relativeToNow -= 31;
            else if (this.range === 'week') this.relativeToNow -= 365;
            this.calendarRange = this.fillRange(this.timeframe);
            this.emitDates();
        },

        next()
        {
            this.area = 'next';
            if (this.range === 'day') this.relativeToNow++;
            else if (this.range === 'week') this.relativeToNow += 7;
            else if (this.range === 'month') this.relativeToNow += 31;
            else if (this.range === 'week') this.relativeToNow += 365;
            this.calendarRange = this.fillRange(this.timeframe);
            this.emitDates();
        },

        custom()
        {
            this.area = 'custom';
            this.relativeToNow = 0;
            this.emitDates();
        },

        setDay()
        {
            this.range = 'day';
            this.calendarRange = this.fillRange(this.timeframe);
            this.emitDates();
        },

        setWeek()
        {
            this.range = 'week';
            this.calendarRange = this.fillRange(this.timeframe);
            this.emitDates();
        },

        setMonth()
        {
            this.range = 'month';
            this.calendarRange = this.fillRange(this.timeframe);
            this.emitDates();
        },

        setYear()
        {
            this.range = 'year';
            this.calendarRange = this.fillRange(this.timeframe);
            this.emitDates();
        },

        emitDates()
        {
            this.$emit('update', { dates: this.timeframe, range: this.range })
        },

        handleCalendarSelectionFrom(range)
        {
            this.area = 'custom';
            this.calendarRange = range;
            this.relativeToNow = moment(range[0]).diff(moment().startOf('day'), 'days');

            this.emitDates();
        }
    }
}
</script>



// WEBPACK FOOTER //
// Rangepicker.vue?3f01ae65